import { patientActions } from "./actions";

const initialState = {
  patientsList: [],
  patientsUI: {
    perPage: 10,
    page: 1,
  },
  loading: false,
  error: "",
  patientsPagination: {},
  currentPatient: {},
  isAddPatientModalShow: false,
  searchPatientsList: [],
};

export const patientsReducer = (
  state = initialState,
  { type, payload } = {}
) => {
  switch (type) {
    case patientActions.GET_SEARCH_PATIENTS:
    case patientActions.GET_PATIENTS:
      return {
        ...state,
        loading: true,
      };
    case patientActions.GET_PATIENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        patientsList: payload.data,
        patientsPagination: payload.pagination,
      };
    case patientActions.GET_PATIENTS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case patientActions.PATIENTS_UI_REFRESH:
      return {
        ...state,
        patientsUI: { ...state.patientsUI, ...payload },
      };
    case patientActions.ADD_PATIENT_MODAL_SHOW:
      return {
        ...state,
        isAddPatientModalShow: true,
      };
    case patientActions.ADD_PATIENT_MODAL_HIDE:
      return {
        ...state,
        isAddPatientModalShow: false,
      };
    case patientActions.CURRENT_PATIENT_REFRESH:
      return {
        ...state,
        currentPatient: payload,
        loading: false,
      };
    case patientActions.SEARCH_PATIENTS_REFRESH:
      return {
        ...state,
        searchPatientsList: [],
      };
    case patientActions.GET_SEARCH_PATIENTS_SUCCESS:
      return {
        ...state,
        searchPatientsList: payload,
        loading: false,
      };
    case patientActions.GET_SEARCH_PATIENTS_ERROR:
      return {
        ...state,
        searchPatientsList: [],
        loading: false,
      };
    default:
      return { ...state };
  }
};
